//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';

import template from './influencers-menu.html';

angular.module('curalate').component('influencersMenu', {
  template,
  controller: ['SessionVarsService', function(SessionVarsService) {
    this.isTrackedSourcesEnabled = SessionVarsService.isFeatureEnabled('tracked_source_management');
    this.isInfluencersManagementV2Enabled = SessionVarsService.isFeatureEnabled('influencers_management_v2');
  }],
});
